import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const PATH_LABELS = {
  dashboard: "Dashboard",
  "compliance-dashboard": "Compliance Dashboard",
  frameworks: "Frameworks",
  controls: "Controls",
  assessments: "Self-Assessments",
  evidence: "Evidence Repository",
  audits: "Audits",
  "audit-calendar": "Audit Calendar",
  risks: "Risk Register",
  "risk-matrix": "Risk Heat Map",
  "risk-trends": "Risk Trends",
  findings: "Findings",
  remediations: "Remediations",
  tasks: "My Tasks",
  organizations: "Organizations",
  users: "Users",
  notifications: "Notifications",
  profile: "Profile",
  settings: "Settings",
  "change-password": "Change Password",
  advisor: "AI Compliance Advisor",
  reports: "Reports",
  "activity-log": "Activity Log",
};

export default function Breadcrumbs() {
  const location = useLocation();
  const parts = location.pathname.split("/").filter(Boolean);

  return (
    <nav
      data-testid="breadcrumbs"
      className="flex items-center gap-1.5 text-sm text-muted-foreground mb-4"
      aria-label="Breadcrumb"
    >
      <Link
        to="/dashboard"
        className="flex items-center gap-1 hover:text-foreground transition-colors"
      >
        <Home className="w-3.5 h-3.5" />
        <span>Home</span>
      </Link>
      {parts.map((seg, idx) => {
        const path = "/" + parts.slice(0, idx + 1).join("/");
        const last = idx === parts.length - 1;
        const label = PATH_LABELS[seg] || decodeURIComponent(seg);
        return (
          <React.Fragment key={path}>
            <ChevronRight className="w-3.5 h-3.5 text-muted-foreground/60" />
            {last ? (
              <span className="text-foreground font-medium">{label}</span>
            ) : (
              <Link to={path} className="hover:text-foreground transition-colors">
                {label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
